import React, { useEffect, useState } from 'react'
import { AddSocialMediaLinks, GetSocialMediaLinks } from '../../Services/allApi'
import { toast, ToastContainer } from 'react-toastify'

function SocialMedia() {
  const [links, setLinks] = useState({ text: '', fb: '', yt: '', x: '' })
  const [allLinks, setAllLinks] = useState([])

  const handleAddNewLink = () => {
    if (links.text && links.fb && links.yt && links.x) {
      setAllLinks([...allLinks, links])
      console.log(allLinks)
      setLinks({ text: '', fb: '', yt: '', x: '' })
    }
    else {
      toast.warning("Please fill the fields")
    }
  }

  const handleEditChange = (index, e) => {
    const { name, value } = e.target;
    const updatedLinks = [...allLinks];
    updatedLinks[index] = { ...updatedLinks[index], [name]: value };
    setAllLinks(updatedLinks);
  }

  const handleRemoveLink = (index) => {
    const updatedLinks = allLinks.filter((_, i) => i !== index);
    setAllLinks(updatedLinks);
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Authorization": `${token}`
    };
    console.log(allLinks);
    const res = await AddSocialMediaLinks(allLinks, reqHeader)
    console.log(res);
    if (res.status == 200) {
      toast.success("Quick link adding successfull")
    } else {
      const messageData = res?.response?.data?.message;
      // Check if messageData is an object
      const errorMessage = typeof messageData === 'object' && messageData !== null
        ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
        : messageData; // If it's a string, use it directly
      // console.log(errorMessage);
      toast.error(errorMessage ?? "There was a problem adding kla");
    }
  }

  useEffect(() => {
    getInitialLiat()
  }, [])
  const getInitialLiat = async () => {
    const res = await GetSocialMediaLinks()
    setAllLinks(res?.data?.data)
  }

  return (
    <>
      <div className='w-full flex items-center flex-col justify-center gap-5'>
        <div className='w-full flex items-center flex-col justify-center bg-gray-100 border border-blue-100 rounded pt-3 pb-5'>
          <div className='flex flex-row justify-center w-full items-center gap-10'>
            <div className='w-2/12 flex flex-col'>
              <label htmlFor="dn">Display name / text</label>
              <input
                value={links.text}
                onChange={(e) => setLinks({ ...links, text: e.target.value })}
                id='dn'
                type="text"
                className='w-full h-10 border border-gray-800 rounded-lg'
              />
            </div>
            <div className='w-2/12'>
              <label htmlFor="url">Facebook link</label>
              <input
                value={links.fb}
                onChange={(e) => setLinks({ ...links, fb: e.target.value })}
                id='url'
                type="text"
                className='w-full h-10 border border-gray-800 rounded-lg'
              />
            </div>
            <div className='w-2/12'>
              <label htmlFor="url">Youtube link</label>
              <input
                value={links.yt}
                onChange={(e) => setLinks({ ...links, yt: e.target.value })}
                id='url'
                type="text"
                className='w-full h-10 border border-gray-800 rounded-lg'
              />
            </div><div className='w-2/12'>
              <label htmlFor="url">Twitter ( x ) link</label>
              <input
                value={links.x}
                onChange={(e) => setLinks({ ...links, x: e.target.value })}
                id='url'
                type="text"
                className='w-full h-10 border border-gray-800 rounded-lg'
              />
            </div>
            <div className='flex flex-col'>
              <label htmlFor="dn" style={{ visibility: 'hidden' }}>Display name / text</label>
              <button onClick={handleAddNewLink} className='px-4 bg-green-500 rounded-lg py-2 text-white'>Add</button>
            </div>
          </div>
        </div>

        {/* Render added links */}
        <div className='flex flex-col w-full gap-2'>
          {allLinks.map((link, index) => (
            <div key={index} className='w-full flex items-center flex-col justify-center bg-success border rounded pb-2'>
              <div className='text-blue-500 flex justify-start w-full ps-2'>
                <p className='text-sm'>Link {index + 1}</p>
              </div>
              <div className='flex flex-row justify-center w-full items-center gap-10'>
                <div className='w-2/12 flex flex-col'>
                  <label htmlFor="dn">Display name / text</label>
                  <input
                    value={link.text}
                    onChange={(e) => handleEditChange(index, e)}
                    name="text"
                    type="text"
                    className='w-full h-10 border border-gray-800 rounded-lg'
                  />
                </div>
                <div className='w-2/12'>
                  <label htmlFor="url">Facebook link</label>
                  <input
                    value={link.fb}
                    onChange={(e) => handleEditChange(index, e)}
                    id='url'
                    type="text"
                    name="fb"
                    className='w-full h-10 border border-gray-800 rounded-lg'
                  />
                </div>
                <div className='w-2/12'>
                  <label htmlFor="url">Youtube link</label>
                  <input
                    value={link.yt}
                    onChange={(e) => handleEditChange(index, e)}
                    id='url'
                    type="text"
                    name="yt"
                    className='w-full h-10 border border-gray-800 rounded-lg'
                  />
                </div><div className='w-2/12'>
                  <label htmlFor="url">Twitter ( x ) link</label>
                  <input
                    value={link.x}
                    onChange={(e) => handleEditChange(index, e)}
                    id='url'
                    type="text"
                    name="x"
                    className='w-full h-10 border border-gray-800 rounded-lg'
                  />
                </div>
                <div className='flex flex-col'>
                  <label htmlFor="dn" style={{ visibility: 'hidden' }}>Display name / text</label>
                  <button
                    onClick={() => handleRemoveLink(index)}
                    className='px-4 bg-red-500 rounded-lg py-2 text-white'
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
          <div className='flex w-full justify-center'><button className='px-8 py-2 rounded-lg mt-5 mb-5 bg-primary text-white' onClick={handleSubmit}>Submit</button></div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  )
}

export default SocialMedia